import { Link } from "react-router-dom";
/* Commenting the following code for logo.ray using AI Agent. 24/08/2026. Comment Start */
// import Logo from "../images/Logo.svg";
/* Commenting end. ray using AI Agent. 24/08/2026 */
/* Added the following code for logo.ray using AI Agent. 24/08/2026. Code Start */
import Logo from "../images/Logo.png";
/* Code end. ray using AI Agent. 24/08/2026 */
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react"; // install via: npm install lucide-react

const Navbar = (props) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    console.log(window.location);
    console.log(props);
  }, []);

  const handleClick = () => {
    window.location.href = "https://winopps.com/login";
  };

  const toggleMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

  const closeMenu = () => setIsMobileMenuOpen(false);

  return (
    <>
      <div className="sticky top-0 z-20 bg-[#021732] border-b-2 border-[#16335a]">
        <div className="flex justify-between items-center py-3 md:py-5 px-4 md:px-16">
          {/* Added the following code for logo.ray using AI Agent. 24/08/2026. Code Start */}
          <div className="inline-flex flex-col items-stretch">
            {/* Commenting the following code for logo.ray using AI Agent. 24/08/2026. Comment Start */}
            {/* <img src={Logo} alt="Logo" className="w-32 md:w-40" /> */}
            {/* <img src={Logo} alt="Logo" className="block h-auto w-40 object-contain drop-shadow-[0_1px_1px_rgba(0,0,0,0.35)] md:w-48" /> */}
            {/* Commenting end. ray using AI Agent. 24/08/2026 */}
            {/* Added the following code for logo.ray using AI Agent. 24/08/2026. Code Start */}
            <img src={Logo} alt="Logo" className="block h-auto w-0 min-w-full object-contain drop-shadow-[0_1px_1px_rgba(0,0,0,0.35)]" />
            <span className="mt-0.5 whitespace-nowrap text-xs font-medium tracking-wide text-white md:text-sm">
              From Learning AI to Building AI
            </span>
            {/* Code end. ray using AI Agent. 24/08/2026 */}
          </div>
          {/* Code end. ray using AI Agent. 24/08/2026 */}

          {/* Hamburger menu (mobile only) */}
          <button
            className="md:hidden text-white"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            {/* {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />} */}
          </button>

          {/* Desktop menu */}
          <div className="hidden md:flex gap-x-3 md:gap-x-6 items-center justify-end text-sm md:text-base font-light">
            <Link
              to="/"
              className={`${
                props.currentItem === "home" ? "text-sky-500" : "text-white"
              } hover:text-sky-500 font-semibold`}
            >
              About
            </Link>
            <Link
              to="/solutions"
              className={`${
                props.currentItem === "solutions"
                  ? "text-sky-500"
                  : "text-white"
              } hover:text-sky-500 font-semibold`}
            >
              Concepts
            </Link>
            <Link
              to="/contact"
              className={`${
                props.currentItem === "pricing" ? "text-sky-500" : "text-white"
              } hover:text-sky-500 font-semibold`}
            >
              Subscribe
            </Link>
            <Link
              to="/blogs"
              className={`${
                props.currentItem === "blogs" ? "text-sky-500" : "text-white"
              } hover:text-sky-500 font-semibold`}
            >
              Blogs
            </Link>
            <Link
              to="/login"
              className="text-white hover:text-sky-500 font-semibold"
            >
              Login
            </Link>
            <Link
              to="/register"
              className="flex justify-center bg-sky-600 hover:bg-sky-500 text-white font-semibold px-2 md:px-6 py-1 md:py-2 rounded-lg"
            >
              Signup
            </Link>
          </div>
        </div>

        {/* Mobile menu */}
        {isMobileMenuOpen && (
          <div className="flex flex-col gap-3 px-4 pb-4 md:hidden text-sm font-semibold text-white bg-[#021732]">
            <Link
              to="/"
              className={props.currentItem === "home" ? "text-sky-500" : ""}
              onClick={closeMenu}
            >
              About
            </Link>
            <Link
              to="/solutions"
              className={props.currentItem === "solutions" ? "text-sky-500" : ""}
              onClick={closeMenu}
            >
              Modules
            </Link>
            <Link
              to="/contact"
              className={props.currentItem === "pricing" ? "text-sky-500" : ""}
              onClick={closeMenu}
            >
              Subscribe
            </Link>
            <Link
              to="/blogs"
              className={props.currentItem === "blogs" ? "text-sky-500" : ""}
              onClick={closeMenu}
            >
              Blogs
            </Link>
            <Link to="/login" onClick={closeMenu}>
              Login
            </Link>
            <Link
              to="/register"
              onClick={closeMenu}
              className="bg-sky-600 hover:bg-sky-500 text-white text-center py-2 rounded-lg"
            >
              Signup
            </Link>
          </div>
        )}
      </div>
    </>
  );
};

export default Navbar;
